module.exports = __webpack_public_path__ + "static/media/UniNeueRegular-Italic.bdc6c4b5.ttf";